import React from 'react'
import { HeaderTitle } from './styles'
import OwnerInfo from '../ownerPanel/OwnerInfo'
import CollectionConnector, { ConnectorProps as ListProps } from '../../connectors/Collection'

export default CollectionConnector(
  (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { featuredSectionData } = props
    return (
      <>
        <HeaderTitle data-type='featured-section'>
          <h3 className='defaultTypographyH3'>{featuredSectionData.collectionName}</h3>
        </HeaderTitle>
        <OwnerInfo
          curatorSectionDataType='featured-section-curator'
          curatorNameDataType='featured-section-curator-name'
          curatorJobDataType='featured-section-curator-job'
          avatarDataType='featured-section-curator-avatar'
          curatorUserId={featuredSectionData.curatorUserId}
          avatarUrl={featuredSectionData.avatar}
          curatorName={featuredSectionData.curatorName}
          jobTitle={featuredSectionData.jobTitle}
        />
      </>
    )
  }
)
